import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { WidgetType } from "scenes/cohort-filters/filter-configs/widgetTypes";

export const autocompleteFieldConstructor = ({
    pathToValue,
    category = Category.OTHER,
    label,
    fieldWidth = 240,
    nestedComponent = false,
}) => ({
    [pathToValue]: {
        category: nestedComponent ? undefined : category,
        widgetType: WidgetType.AUTOCOMPLETE,
        widgetConfig: {
            label,
            width: fieldWidth,
            autoLoadValues: true,
        },
    },
});
